import { create } from "zustand";

interface EditProfileModalState {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const useEditProfileModalStore = create<EditProfileModalState>((set) => ({
  isOpen: false,
  openModal: () => set({ isOpen: true }),
  closeModal: () => set({ isOpen: false }),
}));

export default useEditProfileModalStore;
